export const styledTheme = {
    primaryColor: `#67B7D6`,
    dark: `rgb(20,20,20)`
}